import { config } from "@/config";

export const RELATIVE_PATHS = {
  ALERT_SETTINGS: "settings",
  ALERT_INSIGHTS: "insights",
  MENTIONS_PERIOD: "period/:startDate/:endDate",
};

export const PUBLIC_SITE = "https://allears.ai";
export const PUBLIC_SITE_CAREERS = "https://jobs.allears.ai";

export const PUBLIC_SV_SITE_TERMS = "https://sv.allears.ai/allmanna-villkor";
export const PUBLIC_SV_SITE_PRIVACY_POLICY =
  "https://sv.allears.ai/personuppgiftspolicy";
export const PUBLIC_SV_SITE_COOKIE_POLICY =
  "https://sv.allears.ai/cookie-policy";

export const PUBLIC_EN_SITE_TERMS =
  "https://en.allears.ai/legal/terms-of-service";
export const PUBLIC_EN_SITE_PRIVACY_POLICY =
  "https://en.allears.ai/legal/privacy-policy";
export const PUBLIC_EN_SITE_COOKIE_POLICY =
  "https://sv.allears.ai/cookie-policy";
export const PUBLIC_EN_SITE_DATA_POLICY =
  "https://en.allears.ai/legal/data-processing-agreement";

export const ROUTES = {
  DASHBOARD: `${config.APP_URL}/:orgUuid/__tests__/dashboard_cm0m0uu8s000008jp3a2l8rcz`,

  APP_HOME: `${config.APP_URL}/`,
  APP_HOME_ORGID: `${config.APP_URL}/:orgUuid/`,

  PUBLIC_LOCALIZED: `${config.LOCALIZED_URL}/`,
  // Active alerts:
  MENTION_LIST: `${config.APP_URL}/mentions/`,
  MENTION_LIST_ORGID: `${config.APP_URL}/:orgUuid/mentions/`,
  MENTION_DETAIL: `${config.APP_URL}/mentions/:uuid/`,
  MENTION_DETAIL_ORGID: `${config.APP_URL}/:orgUuid/mentions/:uuid/`,
  MENTION_DETAIL_ORGID_PERIOD: `${config.APP_URL}/:orgUuid/mentions/:uuid/period/:startDate/:endDate`,
  MENTION_INSIGHTS: `${config.APP_URL}/mentions/:uuid/${RELATIVE_PATHS.ALERT_INSIGHTS}/`,
  MENTION_INSIGHTS_ORGID: `${config.APP_URL}/:orgUuid/mentions/:uuid/${RELATIVE_PATHS.ALERT_INSIGHTS}/`,
  MENTION_SETTINGS: `${config.APP_URL}/mentions/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/`,
  MENTION_SETTINGS_ORGID: `${config.APP_URL}/:orgUuid/mentions/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/`,
  MENTION_SETTINGS_HIDDEN_MENTIONS_ORGID: `${config.APP_URL}/:orgUuid/mentions/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/hidden`,
  // Archived alerts:
  ARCHIVE: `${config.APP_URL}/archive/`,
  ARCHIVE_ORGID: `${config.APP_URL}/:orgUuid/archive/`,
  ARCHIVE_DETAIL: `${config.APP_URL}/archive/:uuid/`,
  ARCHIVE_DETAIL_ORGID: `${config.APP_URL}/:orgUuid/archive/:uuid/`,
  ARCHIVE_INSIGHTS: `${config.APP_URL}/archive/:uuid/${RELATIVE_PATHS.ALERT_INSIGHTS}/`,
  ARCHIVE_INSIGHTS_ORGID: `${config.APP_URL}/:orgUuid/archive/:uuid/${RELATIVE_PATHS.ALERT_INSIGHTS}/`,
  ARCHIVE_SETTINGS: `${config.APP_URL}/archive/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/`,
  ARCHIVE_SETTINGS_ORGID: `${config.APP_URL}/:orgUuid/archive/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/`,

  // Saved searches:
  SAVED_SEARCHES: `${config.APP_URL}/saved-searches/`,
  SAVED_SEARCHES_ORGID: `${config.APP_URL}/:orgUuid/saved-searches/`,
  SAVED_SEARCHES_DETAIL: `${config.APP_URL}/saved-searches/:uuid/`,
  SAVED_SEARCHES_DETAIL_ORGID: `${config.APP_URL}/:orgUuid/saved-searches/:uuid/`,
  SAVED_SEARCHES_INSIGHTS: `${config.APP_URL}/saved-searches/:uuid/${RELATIVE_PATHS.ALERT_INSIGHTS}/`,
  SAVED_SEARCHES_INSIGHTS_ORGID: `${config.APP_URL}/:orgUuid/saved-searches/:uuid/${RELATIVE_PATHS.ALERT_INSIGHTS}/`,
  SAVED_SEARCHES_SETTINGS: `${config.APP_URL}/saved-searches/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/`,
  SAVED_SEARCHES_SETTINGS_ORGID: `${config.APP_URL}/:orgUuid/saved-searches/:uuid/${RELATIVE_PATHS.ALERT_SETTINGS}/`,

  MENTION_NEW: `${config.APP_URL}/mentions/new/`,
  TAGS_ORGID: `${config.APP_URL}/:orgUuid/tags/`,
  TAGS: `${config.APP_URL}/tags/`,
  TAG_ORGID: `${config.APP_URL}/:orgUuid/tags/:slug/`,
  TAG: `${config.APP_URL}/tags/:slug/`,
  FAVORITES: `${config.APP_URL}/favorites/`,
  FAVORITES_ORGID: `${config.APP_URL}/:orgUuid/favorites/`,
  MENTIONS_ANCHOR: `${config.APP_URL}/mentions/:search_uuid/:mention_uuid/`,
  MENTIONS_ANCHOR_ORGID: `${config.APP_URL}/:orgUuid/mentions/:search_uuid/:mention_uuid/`,
  MENTION_INSIGHTS_SHARE: `${config.APP_URL}/reports/:report_uuid/share/`,

  TAG_EXPORT_RSS: `${config.LOCALIZED_URL}/organization/:organization_uuid/tags/rss/:slug`,
  TAG_PUBLIC: `${config.LOCALIZED_URL}/reports/tags/:id/`,

  SEARCH_EXPORT_RSS: `${config.LOCALIZED_URL}/reports/rss/:search_uuid/`,
  SEARCH_EXPORT_API: `/reports/:search_uuid.json`,

  SEARCH: `${config.APP_URL}/search/`,
  SEARCH_ORGID: `${config.APP_URL}/:orgUuid/search/`,
  SEARCH_PREVIEW_ORGID: `${config.APP_URL}/:orgUuid/search/preview/`,
  SEARCH_SUBMIT_ORGID: `${config.APP_URL}/:orgUuid/search/preview/submit/`,
  REPORTS: `${config.APP_URL}/reports/`,
  REPORTS_ORGID: `${config.APP_URL}/:orgUuid/reports/`,
  REPORT: `${config.API_URL}/reports/:uuid/`,
  REPORTS_NEW: `${config.APP_URL}/reports/new/`,
  REPORTS_NEW_ORGID: `${config.APP_URL}/:orgUuid/reports/new/`,
  REPORTS_EDIT_SUBSCRIPTIONS: `${config.APP_URL}/reports/edit/:uuid/subscriptions/`,
  REPORTS_EDIT_SUBSCRIPTIONS_ORGID: `${config.APP_URL}/:orgUuid/reports/edit/:uuid/subscriptions/`,

  MENTIONS_SINGLE_PUBLIC: `${config.LOCALIZED_URL}/m/:slug--:uuid/`,
  ALERT_PUBLIC: `${config.LOCALIZED_URL}/reports/:slug--:uuid/`,
  REPORT_PUBLIC: `${config.APP_URL}/reports/t/:token/`,
  INSIGHTS_PUBLIC: `${config.APP_URL}/insights/t/:token/`,
  REPORTS_EDIT: `${config.APP_URL}/reports/edit/:uuid/`,
  REPORTS_EDIT_ORGID: `${config.APP_URL}/:orgUuid/reports/edit/:uuid/`,

  // Settings routes
  SETTINGS: `${config.APP_URL}/settings/`,
  SETTINGS_ORGID: `${config.APP_URL}/:orgUuid/settings/`,
  SETTINGS_EMAIL: `${config.APP_URL}/settings/email/`,
  SETTINGS_EMAIL_ORGID: `${config.APP_URL}/:orgUuid/settings/email/`,
  SETTINGS_TEAM: `${config.APP_URL}/settings/team/`,
  SETTINGS_TEAM_ORGID: `${config.APP_URL}/:orgUuid/settings/team/`,
  SETTINGS_TEAM_USER_ORGID: `${config.APP_URL}/:orgUuid/settings/team/users/:userId/`,
  SETTINGS_TEAM_DELETE_USER_ORGID: `${config.APP_URL}/:orgUuid/settings/team/users/:userId/delete`,
  SETTINGS_TEAM_INVITE_USER_ORGID: `${config.APP_URL}/:orgUuid/settings/team/invite`,
  SETTINGS_API: `${config.APP_URL}/settings/api/`,
  SETTINGS_API_ORGID: `${config.APP_URL}/:orgUuid/settings/api/`,
  SETTINGS_CHANGE_PASSWORD: `${config.APP_URL}/settings/change-password/`,
  SETTINGS_CHANGE_PASSWORD_ORGID: `${config.APP_URL}/:orgUuid/settings/change-password/`,
  WELCOME: `${config.APP_URL}/welcome/`,

  INVITE_USER: `${config.APP_URL}/users/add`,
  INVITE_USER_ORGID: `${config.APP_URL}/:orgUuid/users/add`,

  LOGOUT: `/logout/`,
  LOGIN: `/login/`,
  LOGIN_LOCALIZED: `${config.LOCALIZED_URL}/login/`,
  LOGIN_SSO_GOOGLE: `/login/google/`,
  LOGIN_SSO_AZURE: `/login/azure/`,
  SIGNUP_SSO_GOOGLE: `/signup/google/`,
  SIGNUP_SSO_AZURE: `/signup/azure/`,
  FORGOT_PASSWORD: `/password_reset/`,
  ACTIVATION: `/activation/:activation_key/`,

  SIGNUP: "/signup",
  SIGNUP_LOCALIZED: `${config.LOCALIZED_URL}/signup/`,
  SIGNUP_INFO_LOCALIZED: `${config.LOCALIZED_URL}/signup/info/`,
  SIGNUP_CONFIRM_LOCALIZED: `${config.LOCALIZED_URL}/signup/confirm/`,

  BILLING_PORTAL: `/billing-portal/`,
};

export const INTERNAL_ROUTES = {
  BASE: `${config.INTERNAL_APP_URL}/`,
  CHANNEL_LIST: `${config.INTERNAL_APP_URL}/channels/`,
  CHANNEL_DETAIL: `${config.INTERNAL_APP_URL}/channels/:id/`,
};
